
export default function Footer() {
  return (
    <footer className="bg-black text-white pt-12 pb-6 border-t border-gray-800">
      <div className="container mx-auto px-4">
        {/* Logo and Brand - Centralized */}
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <img 
              src="https://static.readdy.ai/image/bbf7646a0d8dd47b9253598fe9d72fca/a105293fe1c45d8b09e78eb42c1df2c7.png"
              alt="Marco Pombo - Ilusionista"
              className="h-20 w-auto"
            />
          </div>
          <div>
            <h3 className="text-xl font-elegant font-bold mb-2">
              <span className="text-red-600">M</span>arco <span className="text-red-600">P</span>ombo
            </h3>
            <p className="text-gray-400">Ilusionista & Stand-up Magic</p>
          </div>
        </div>

        {/* Contact Info - Horizontal Layout */}
        <div className="flex flex-wrap justify-center items-center gap-8 mb-6">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-red-600 rounded-full flex items-center justify-center">
              <i className="ri-phone-line text-white text-sm"></i>
            </div>
            <span className="text-gray-300 text-sm">+34 698 13 87 11</span>
          </div>
          
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-red-600 rounded-full flex items-center justify-center">
              <i className="ri-mail-line text-white text-sm"></i>
            </div>
            <span className="text-gray-300 text-sm">contacto@ilusionistamarcopombo.com</span>
          </div>
          
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-red-600 rounded-full flex items-center justify-center">
              <i className="ri-map-pin-line text-white text-sm"></i>
            </div>
            <span className="text-gray-300 text-sm">Galicia, Pontevedra</span>
          </div>
        </div>

        {/* Social Media - Centered */}
        <div className="text-center mb-6">
          <div className="flex justify-center space-x-3">
            <a href="https://www.facebook.com/profile.php?id=61578282357138" target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-gray-800 hover:bg-red-600 text-white rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer">
              <i className="ri-facebook-fill text-sm"></i>
            </a>
            <a href="https://www.instagram.com/ilusionistamarcopombo" target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-gray-800 hover:bg-red-600 text-white rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer">
              <i className="ri-instagram-line text-sm"></i>
            </a>
            <a href="https://www.youtube.com/@magomarco" target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-gray-800 hover:bg-red-600 text-white rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer">
              <i className="ri-youtube-line text-sm"></i>
            </a>
            <a href="https://www.linkedin.com/in/marco-pombo-540278386/" target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-gray-800 hover:bg-red-600 text-white rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer">
              <i className="ri-linkedin-fill text-sm"></i>
            </a>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="border-t border-gray-800 pt-4 text-center text-gray-400 text-xs">
          <p>© 2025 Marco Pombo. Todos los derechos reservados.</p>
        </div>

      </div>
    </footer>
  );
}
